/**
 * Cache client des listes de contenu (blocks / items / entities / crafts) par (kind, groupe).
 * Évite de re-scanner + re-transférer + re-rendre à chaque navigation entre pages Config.
 * TTL court ; vidé après une modification ou une synchro de groupe.
 */
const TTL_MS = 60_000;

interface Entry {
  at: number;
  data: unknown[];
}

const cache = new Map<string, Entry>();

export function listCacheKey(kind: string, groupId: string): string {
  return `${kind}::${groupId}`;
}

export function getCachedList<T>(key: string): T[] | null {
  const e = cache.get(key);
  if (!e) return null;
  if (Date.now() - e.at > TTL_MS) {
    cache.delete(key);
    return null;
  }
  return e.data as T[];
}

export function setCachedList<T>(key: string, data: T[]): void {
  cache.set(key, { at: Date.now(), data });
}

/** Vide le cache (tout, ou seulement les entrées d'un groupe donné). */
export function clearConfigListCache(groupId?: string): void {
  if (!groupId) {
    cache.clear();
    return;
  }
  const suffix = `::${groupId}`;
  for (const k of [...cache.keys()]) if (k.endsWith(suffix)) cache.delete(k);
}
